/**
 * Created by moran on 6/7/17.
 */
export const TIME_SPENT = 'TIME_SPENT';
export const LISTENING = 'LISTENING';
export const EXPLAINING_CLEARLY = 'EXPLAINING_CLEARLY';
export const CARE_DECISIONS = 'CARE_DECISIONS';
